import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import {DepositTable} from "../../UI/Deposits/DepositTable";

const Deposits = () => {
  return (
    <div>
      <PanelHead title="Transaction" />
      <PanelBody content={<DepositTable />} />
    </div>
  );
};

export default React.memo(Deposits);
